import type { Calculation } from "@suse-o11y/calculate-value-from-points";
import type { FormatterUnit } from "@suse-o11y/formatter-unit";
import type { SortDirection } from "@suse-o11y/sort-by";

import type { PieChartType } from "~/components/pie-chart/utils";

import { DEFAULT as DEFAULT_LEGEND, type Settings as LegendSettings } from "../legend/settings";

interface Settings {
	unit?: string;
	decimals?: number;
	calculation?: Calculation;
	sort?: SortDirection;
	type?: PieChartType;
	legend?: LegendSettings;
}

const DEFAULT = {
	unit: "none" satisfies FormatterUnit,
	decimals: undefined,
	calculation: "last",
	sort: "desc",
	type: "pie" satisfies PieChartType,
	legend: DEFAULT_LEGEND,
} as const satisfies Settings;

export type { Settings };
export { DEFAULT };
